import { createAsyncThunk } from '@reduxjs/toolkit'

import {
  type ISearchInput,
  type ISearchResponse,
  objectToQueryString,
} from '@sales-center/common'

import type { CoreEmployeeModel } from './typings'
import { ServiceConfig } from '../services/config'
import { get, type APIError } from '../services/crud'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.scheduling.scheduling}`

export const getTechs = createAsyncThunk<
  ISearchResponse<CoreEmployeeModel>,
  ISearchInput | undefined,
  { rejectValue: APIError }
>('techs/get', async (request = {}, thunkApi) => {
  const qstring = objectToQueryString(request)

  const response = await get(
    `${baseUrl}${ServiceConfig.scheduling.employee}?${qstring}`,
  )

  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})
